import DimensionsSearchSkeleton from "./DimensionsSearchSkeleton";

export default DimensionsSearchSkeleton;
